import React, { Fragment } from 'react';

import { Skeleton } from '@material-ui/lab';

import { MobiCopilotGreenIcon } from 'modules/mobiCopilot/utils/constants';

import * as S from './styles';

interface Props {
  isFullScreen: boolean;
  isLoading?: boolean;
  messageSuggestions?: string[];
  onSelectSuggestion: (value: string) => void;
  userName: string;
}

export function InitialMessage({
  isFullScreen,
  isLoading = false,
  messageSuggestions = [],
  onSelectSuggestion,
  userName,
}: Props) {
  if (!messageSuggestions) return <Fragment />;

  return (
    <S.InitialMessageContainer data-is-fullscreen={isFullScreen}>
      <S.InitialMessage className="content">
        <S.Avatar>
          <MobiCopilotGreenIcon />
        </S.Avatar>
        {isLoading &&
          [0, 1, 3].map((_, index) => (
            <S.LoadingMessages
              key={`loading-messages-${index}`}
              variant="rect"
              width={200}
              height={28}
            />
          ))}
        {!isLoading && (
          <Fragment>
            <p>
              Olá {userName}, sou o <strong>Mobi Copiloto</strong>. 😊
            </p>
            <p>Como posso te ajudar hoje?</p>
          </Fragment>
        )}
      </S.InitialMessage>
      <S.InitialMessageOptions className="options">
        {isLoading &&
          [0, 1, 2].map((_, index) => (
            <li key={`loading-suggestion-${index}`}>
              <Skeleton variant="rect" width="100%" height="40px" />
            </li>
          ))}
        {!isLoading &&
          messageSuggestions.map((message, messageIndex) => (
            <li key={`message-suggestion-${messageIndex}`}>
              <S.Option
                disabled={isLoading}
                label={message}
                onClick={() => onSelectSuggestion(message)}
                variant="outlined"
              />
            </li>
          ))}
      </S.InitialMessageOptions>
    </S.InitialMessageContainer>
  );
}
